import React, { useEffect, useState, useContext } from 'react';
import styled, { keyframes, css } from "styled-components";
import ChatGlobalContext from "../context/ChatGlobalContext";
import { IoIosCloseCircleOutline } from "react-icons/io";
import axios from 'axios';
import ReactMarkdown from 'react-markdown'
import gfm from 'remark-gfm'


const Bar = styled.div`
    background-color: #f9423a;
    width: 100%;
    -webkit-box-shadow: 2px 1px 12px 0px rgba(0, 0, 0, 0.35);
    -moz-box-shadow: 2px 1px 12px 0px rgba(0, 0, 0, 0.35);
    box-shadow: 2px 1px 12px 0px rgba(0, 0, 0, 0.35);
`;

const Content = styled.div`
    position: relative;
    margin: 0px auto;
    width: calc(100% - 10px);
    padding: 0px 5px;
    max-width: 1338px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    align-content: center;
    flex-direction: row;
    gap: 10px;
    small { p { 
        color: #000000 !important; 
        margin: 0px !important;
        flex: 1;
        text-align: center;
        font-size: 14px !important;
        font-weight: 400;
        line-height: 21px !important;
    }}
    span {
        color: #000000;
        marging: 0px;
        padding: 0px;
        cursor: pointer;
        transition: all 0.3s ease-in-out;
        svg { transition: all 0.3s ease-in-out; }
        &:hover {
            color: #ffffff;
            svg { transform: rotate(-90deg); }
        }
    }
`;

const ChatNotificationBar = () => {
    const gContext: any = useContext(ChatGlobalContext);
    const [message, setMessage] = useState<string|null>(null);
    const [showBar, setShowBar] = useState<boolean>(true);

    useEffect(() => {
        axios.get(`https://strapi.youfibre.com/api/information`)
            .then(function (response) {
                gContext.setAppMessages(response.data.data);
            })
            .catch(function (error) {
                gContext.setAppMessages(null);
            });
    }, []);

    useEffect(() => {
        setMessage(gContext?.appMessages?.chat_banner_toggle ? gContext?.appMessages?.chat_banner_text : '');
    }, [gContext.appMessages]);
    
    return (
        <>
            {message && showBar && <Bar className="text-white p-1">
                <Content>
                    <small><div className="p-0"><ReactMarkdown remarkPlugins={[gfm]} components={{ a: ({node, ...props}: any) => <a {...props} target="_blank" rel="noopener noreferrer" /> }}>{message}</ReactMarkdown></div></small>
                    <span onClick={() => setShowBar(false)}><IoIosCloseCircleOutline /></span>
                </Content>
            </Bar>}
        </>
    );
};

export default ChatNotificationBar;